import { render, staticRenderFns } from "./LoadCreps.vue?vue&type=template&id=058d0182&scoped=true&"
import script from "./LoadCreps.vue?vue&type=script&lang=js&"
export * from "./LoadCreps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058d0182",
  null
  
)

export default component.exports